const OLYMPIAD_COACH = "https://www.olympiadcoach.com/";
const CHAPTER_PACKAGES =
  "https://www.olympiadcoach.com/General/OlympiadandTalentExamsChapterwiseTests.aspx";
const UIMO_MOCK_TESTS =
  "https://www.olympiadcoach.com/General/UIMO-Mock-Tests-Package-Details.aspx";
const UIMO_PAST_PAPERS =
  "https://www.olympiadcoach.com/General/UIMOPreviousExamPapers.aspx";
const ABOUT_OLYMPIAD_COACH =
  "https://www.olympiadcoach.com/General/AboutUs.aspx";
const UICO_PAST_PAPERS =
  "https://www.olympiadcoach.com/General/NSTSEUCO.aspx";
const ALLOWED_DETAIL_LINKS = new Set([ABOUT_OLYMPIAD_COACH, CHAPTER_PACKAGES]);

const PACKAGE_DETAILS = {
  nstse: [
    {
      title: "NSTSE Registration (Classes 1-10)",
      paragraphs: [
        "Examination Fee + Student’s Performance Report (SPR) + 2 Previous Question Papers (PQP) - Downloadable E-book + Success Series - Downloadable E-book.",
      ],
    },
    {
      title: "NSTSE Registration + Online Preparation Packages & Previous 5 Years Question Papers (Classes 1-10)",
      paragraphs: [
        `Online Olympiad preparation package (Chapter-wise preparation) for Math and Science from ${OLYMPIAD_COACH} for getting a grip on these subjects and the pattern of questions asked in NSTSE.`,
      ],
      links: [
        { label: "Chapter-wise preparation package — Mathematics", href: CHAPTER_PACKAGES },
        { label: "Chapter-wise preparation package — Science", href: CHAPTER_PACKAGES },
        { label: "Previous 5 years Question Papers", href: CHAPTER_PACKAGES },
        {
          label: "More details about Olympiad Coach and the above packages",
          href: CHAPTER_PACKAGES,
        },
      ],
      paragraphsAfter: [
        "The above packages are available at a discounted price with NSTSE registration.",
        "These packages provide you with ample practice, so that you can master these subjects.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
    {
      title: "NSTSE Registration + Online Preparation Packages (Classes 1-10)",
      paragraphs: [
        `Online Olympiad preparation package (Chapter-wise preparation) for Math and Science from ${OLYMPIAD_COACH} for getting a grip on these subjects and the pattern of questions asked in NSTSE.`,
      ],
      links: [
        { label: "Chapter-wise preparation package — Mathematics", href: CHAPTER_PACKAGES },
        { label: "Chapter-wise preparation package — Science", href: CHAPTER_PACKAGES },
        {
          label: "Mock Test — Mathematics, about 50 tests",
          href: "https://www.olympiadcoach.com/General/OlympiadandTalentExamsMockTests_Mathematics.aspx",
        },
        {
          label: "Mock Test — Science, about 50 tests",
          href: "https://www.olympiadcoach.com/General/OlympiadandTalentExamsMockTests_Science.aspx",
        },
        { label: "Previous 5 years Question Papers", href: CHAPTER_PACKAGES },
        {
          label: "More details about Olympiad Coach and the above packages",
          href: CHAPTER_PACKAGES,
        },
      ],
      paragraphsAfter: [
        "The above packages are available at a discounted price with NSTSE registration.",
        "These packages provide you with ample practice, so that you can master these subjects.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
  ],
  uimo: [
    {
      title: "UIMO Online Registration (Classes 1-10)",
      paragraphs: [
        "This registration fee includes Examination Fee + Student’s Performance Report (SPR) + 2 Previous Question Papers (PQP) - Downloadable E-book + Maths Success - Downloadable E-book.",
      ],
    },
    {
      title: "UIMO Online Registration + Past 5 Years Question Papers Package (Classes 1-10)",
      paragraphs: [
        `This registration includes the Online UIMO Mock Tests package and Online Past 5 Years Question Papers Package from ${OLYMPIAD_COACH} for practice and familiarization with the pattern of questions asked in UIMO.`,
      ],
      links: [
        { label: "UIMO Mock Tests", href: UIMO_MOCK_TESTS },
        { label: "UIMO Past 5 Years Question Papers Package", href: UIMO_PAST_PAPERS },
        { label: "More details about Olympiad Coach", href: ABOUT_OLYMPIAD_COACH },
      ],
      paragraphsAfter: [
        "The above package is available with UIMO registration.",
      ],
    },
    {
      title: "UIMO Online Registration + Online Preparation Packages (Classes 1-10)",
      paragraphs: [
        `This registration includes the Online UIMO Mock Tests package and Past 5 Years Question Papers Package from ${OLYMPIAD_COACH},and Reasoning Aptitude Chapter-wise Tests`,
      ],
      links: [
        { label: "UIMO Mock Tests", href: UIMO_MOCK_TESTS },
        { label: "UIMO Past 5 Years Question Papers Package", href: UIMO_PAST_PAPERS },
        { label: "More details about Olympiad Coach", href: ABOUT_OLYMPIAD_COACH },
        { label: "Reasoning Aptitude Chapter-wise Tests", href: "https://www.logiqguru.com/" },
        { label: "More details about LOGIQGURU", href: "https://www.logiqguru.com/" },
      ],
      paragraphsAfter: [
        "The above packages are available with UIMO registration.",
        "This package provides ample practice, so that you can master the subject.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
  ],
  uieo: [
    {
      title: "UIEO Online Registration (Classes 2-10)",
      paragraphs: [
        "This registration fee includes Examination Fee + Student’s Performance Report (SPR) + 2 Previous Question Papers (PQP) - Downloadable E-book + English Success - Downloadable E-book.",
      ],
    },
    {
      title: "UIEO Online Registration + Past 5 Years Question Papers Package (Classes 2-10)",
      paragraphs: [
        `This registration includes the Online Past 5 Years Question Papers Package from ${OLYMPIAD_COACH} for practice and familiarization with the pattern of questions asked in UIEO.`,
      ],
      links: [
        {
          label: "UIEO Past 5 Years Question Papers Package",
          href: "https://unifiedcouncil.com/Options-UIEO-online-2.html#",
        },
        { label: "More details about Olympiad Coach", href: ABOUT_OLYMPIAD_COACH },
      ],
      paragraphsAfter: [
        "The above package is available with UIEO registration.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
    {
      title: "UIEO Online Registration + Online Preparation Packages (Classes 2-10)",
      paragraphs: [
        `Online Olympiad preparation package (Chapter-wise preparation) for English from ${OLYMPIAD_COACH} to build a strong understanding of the subject and the pattern of questions asked in UIEO.`,
      ],
      links: [
        { label: "Chapter-wise preparation package — English", href: CHAPTER_PACKAGES },
        { label: "English Mock Tests", href: CHAPTER_PACKAGES },
        {
          label: "UIEO Past 5 Years Question Papers Package",
          href: "https://unifiedcouncil.com/Options-UIEO-online-2.html#",
        },
        {
          label: "More details about Olympiad Coach and the above packages",
          href: CHAPTER_PACKAGES,
        },
      ],
      paragraphsAfter: [
        "The above packages are available at a discounted price with UIEO registration.",
        "These packages provide you with ample practice, so that you can master these subjects.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
  ],
  uico: [
    {
      title: "UCO Online Registration (Classes 2-10)",
      paragraphs: [
        "This registration fee includes Examination Fee + Student’s Performance Report (SPR) + 2 Previous Question Papers (PQP) - Downloadable E-book + Cyber Success - Downloadable E-book.",
      ],
    },
    {
      title: "UCO Online Registration + Past 5 Years Question Papers Package (Classes 2-10)",
      paragraphs: [
        `This registration includes the Online Past 5 Years Question Papers Package from ${OLYMPIAD_COACH} for practice and familiarization with the pattern of questions asked in UCO.`,
      ],
      links: [
        { label: "UCO Past 5 Years Question Papers Package", href: UICO_PAST_PAPERS },
        { label: "More details about Olympiad Coach", href: ABOUT_OLYMPIAD_COACH },
      ],
      paragraphsAfter: [
        "The above package is available with UCO registration.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
    {
      title: "UCO Online Registration + Online Preparation Packages (Classes 2-10)",
      paragraphs: [
        `Online Olympiad preparation packages (Reasoning Chapter-wise Tests and Computer Mock Tests) for Cyber Exam from ${OLYMPIAD_COACH} to build a strong understanding of these subjects and the pattern of questions asked in UCO.`,
      ],
      links: [
        { label: "Reasoning Aptitude Chapter-wise Tests package", href: CHAPTER_PACKAGES },
        { label: "Computer Mock Tests", href: CHAPTER_PACKAGES },
        { label: "UCO Past 5 Years Question Papers Package", href: UICO_PAST_PAPERS },
        {
          label: "More details about Olympiad Coach and the above packages",
          href: CHAPTER_PACKAGES,
        },
      ],
      paragraphsAfter: [
        "The above packages are available at a discounted price with UCO registration.",
        "These packages provide you with ample practice, so that you can master these subjects.",
        "Your online packages will be activated within 48 hours and you will be informed accordingly through SMS. For doubts and discrepancies, contact support@olympiadcoach.com or call 7729997306.",
      ],
    },
  ],
};

const RegistrationPackageDetails = ({ examId, maxOption }) => {
  const options = PACKAGE_DETAILS[examId]?.slice(0, maxOption);

  if (!options) return null;

  return (
    <section className="py-16 bg-white" aria-labelledby="registration-package-details">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2
            id="registration-package-details"
            className="text-3xl md:text-4xl font-black text-slate-800"
          >
            Registration Package Details
          </h2>
          <p className="text-lg text-slate-600 mt-3">
            Details for the selected registration option and all included options.
          </p>
        </div>
        <div className="space-y-6">
          {options.map((option, index) => (
            <article
              key={option.title}
              className="rounded-3xl border border-slate-200 bg-slate-50 p-6 md:p-8"
            >
              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-5">
                <div>
                  <p className="text-sm font-bold uppercase tracking-wide text-slate-500">
                    Option {index + 1}
                  </p>
                  <h3 className="text-xl md:text-2xl font-black text-slate-800 mt-1">
                    {option.title}
                  </h3>
                </div>
              </div>
              <div className="space-y-4 text-slate-700 leading-relaxed">
                {option.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {option.links?.length > 0 && (
                  <ul className="list-disc space-y-2 pl-6">
                    {option.links.map((link) => (
                      <li key={link.label}>
                        {ALLOWED_DETAIL_LINKS.has(link.href) ? (
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-semibold text-blue-700 underline hover:text-blue-900"
                          >
                            {link.label}
                          </a>
                        ) : (
                          <span>{link.label}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
                {option.paragraphsAfter?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {option.paragraphsAfter?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RegistrationPackageDetails;
